import React, { useEffect } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Stack,
    Select,
    Text,
    Flex,
    RadioGroup,
    Radio,
} from '@chakra-ui/react'
import Input from './Input';
import { useState } from 'react';
import { FaUser, FaUserAlt } from "react-icons/fa";
import Button from './Button';
import {ApproveTransfer } from '../Utils/ApiCalls';
import { SiQuantcast } from 'react-icons/si';
import { ImPriceTag } from 'react-icons/im';
import { BsFillBookmarkCheckFill } from 'react-icons/bs';



export default function ApproveAction({ isOpen, onOpen, onClose, id, qty, state }) {



    const [ApprovalPayload, setApprovalPayload] = useState({
        supervisorremark: "",
        approvalresponse: true
    });






    const [errorMsg, setErrorMsg] = useState({
        status: false,
        msg: ""
    });

    const [SuccessMsg, setSuccessMsg] = useState({
        status: false,
        msg: "sdfgvhbnm"
    });


    const [Loading, setLoading] = useState(false);
    const [LoadingReject, setLoadingReject] = useState(false);


   

    const Approve = async () => {
        try {
            setLoadingReject(true);
            console.log("Payloadtransfer", ApprovalPayload);
            let result = await ApproveTransfer(ApprovalPayload, id)
            console.log("result", result);
            if (result.status == true) {
                setLoadingReject(false)
                setSuccessMsg({
                    status: true,
                    msg: "Approval successfully"
                })


                setApprovalPayload({
                    supervisorremark: "",
                    approvalresponse: true
                })

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,
                        msg: ""
                    })
                  onClose()

                }, 3000);

            } else {
                setLoadingReject(false)
                setErrorMsg({
                    status: true,
                    msg: result.msg
                })
                setTimeout(() => {
                    setApprovalPayload({
                        supervisorremark: "",
                        approvalresponse: true
                    })
                    setErrorMsg({
                        status: false,
                        msg: ""
                    })
                }, 3000);


            }


        } catch (e) {

            setLoadingReject(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })

            setTimeout(() => {
                setErrorMsg({
                    status: false,
                    msg: e.message
                })

            }, 3000);
            console.error('Error:', e.message);
        }


    }
 
   

  
    const handleApprovalPayload = (e) => {
        setApprovalPayload({ ...ApprovalPayload, [e.target.id]: e.target.value })
    }

    console.log("ApprovalPayload", ApprovalPayload);

    useEffect(() => {

    }, [isOpen]);



    return (



        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Approve</ModalHeader>
                <ModalCloseButton />
                <ModalBody>

                    {
                        state === "ApprovalTransfer" && (

                            <div>

                                <Stack spacing={"15px"}>
                                    <Input leftIcon={<BsFillBookmarkCheckFill />} iconColor="black" labelBg='#fff' label='Supervisor Remark' id="supervisorremark" type='text' value={ApprovalPayload.supervisorremark} val={ApprovalPayload.supervisorremark != "" ? true : false} onChange={handleApprovalPayload} />


                                </Stack>



                                <Flex justifyContent={"center"}>
                                    <Button w='45%' mt="14px" isLoading={LoadingReject}
                                        disabled={ApprovalPayload.supervisorremark != "" ? false : true}
                                        onClick={Approve} background="green">Approve
                                    </Button>


                                </Flex>
                            </div>
                        )
                    }



                    {
                        errorMsg.status && (
                            <Text mt={"10px"} color="red.200" textAlign="center">{errorMsg.msg}</Text>
                        )
                    }

                    {
                        SuccessMsg.status && (
                            <Text mt={"10px"} color="green" textAlign="center">{SuccessMsg.msg}</Text>
                        )
                    }

                </ModalBody>

                <ModalFooter>


                </ModalFooter>
            </ModalContent>
        </Modal>

    )
}
